export class EnvService {

  // The values that are defined here are the default values that can
  // be overridden by env.js

  // API url
  public APP_BACKEND_PATH = '';

  // Recaptcha Key
  public APP_RECAPTCHA_KEY = '';

  constructor() {
  }

}
